// extracted by mini-css-extract-plugin
module.exports = {"invite-confirm":"FinishBtn_invite-confirm__cMA_Y","invite-url":"FinishBtn_invite-url__292Zv","invite-tip":"FinishBtn_invite-tip__158mV"};